var React = require('react');

function Caret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.000593531 5.10333C0.000593531 3.7917 0.495219 2.5313 1.43422 1.52297C3.36246 -0.442453 6.52935 -0.442453 8.4574 1.52297L23.495 16.7996L38.5306 1.47407C40.4589 -0.491356 43.6258 -0.491356 45.5538 1.47407C47.4821 3.43949 47.4821 6.66744 45.5538 8.63266L27.0073 27.5387C26.0683 28.4958 24.8318 29 23.4947 29C22.1596 29 20.9231 28.4446 19.9821 27.5387L1.43362 8.68207C0.494625 7.67375 0 6.36409 0 5.10368L0.000593531 5.10333Z","fill":"black"}));
}

Caret.defaultProps = {"width":"47","height":"29","viewBox":"0 0 47 29","fill":"none"};

module.exports = Caret;

Caret.default = Caret;
